import Events from '../events';
/**
 * Create the action
 */

const { thunk, request, success, error } = Events.index((fetch) =>
    fetch.get('events')
);

/**
 * Export the components
 */

export { thunk as default };
export { request, success, error };
